import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { getTabState } from "../services/form.service";

function TabItems(props) {
  const {
    value,
    tabRef,
    tabItems,
    currentData,
    showReviewTab,
    applicationId = "",
    handleTabChange,
  } = props;

  const handleDisable = (tab, formData, tabIndex) => {
    if (applicationId === "new" && tabIndex !== 0) {
      tabRef.current = { ...tabRef.current, [tabIndex]: true };
      return true;
    }
    const isDisabled = getTabState(tab, formData);
    tabRef.current = { ...tabRef.current, [tabIndex]: isDisabled };
    return isDisabled;
  };

  return (
    <Tabs
      value={value}
      onChange={handleTabChange}
      variant="scrollable"
      allowScrollButtonsMobile
      aria-label="form tabs"
      className="tabList"
      slotProps={{ indicator: { sx: { bgcolor: "transparent" } } }}
    >
      {tabItems.map(
        (tab, i) =>
          tab.type === "panel" &&
          tab.title !== "Actions" && (
            <Tab
              label={tab.title}
              // eslint-disable-next-line react/no-array-index-key
              key={`${tab.key}-${i}`}
              id={`form-tab-${i}`}
              aria-controls={`form-tabpanel-${i}`}
              disabled={handleDisable(tab, currentData, i)}
              wrapped={tab.title?.length > 28}
              disableFocusRipple
            />
          )
      )}
      {showReviewTab && (
        <Tab
          label="Review"
          id="form-tab-review"
          aria-controls={`form-tabpanel-${tabItems.length}`}
          disabled={applicationId === "new"}
          disableFocusRipple
        />
      )}
    </Tabs>
  );
}

export default TabItems;
TabItems.propTypes = {
  value: PropTypes.number.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  tabItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentData: PropTypes.shape({}).isRequired,
  showReviewTab: PropTypes.bool.isRequired,
  applicationId: PropTypes.string,
  tabRef: PropTypes.shape({ current: PropTypes.shape({}) }).isRequired,
};
TabItems.defaultProps = {
  applicationId: "",
};
